import m from "../../geodata/es2015/frenchGuianaLow";
window.am4geodata_frenchGuianaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/frenchGuianaLow.js
// module id = null
// module chunks = 